///<reference path="../../ui/widgets/counter.component.ts"/>
import {
    AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ComponentFactoryResolver, Renderer2,
    Injector, ApplicationRef
} from '@angular/core';
import {EventService} from '../../core/services/event.service';
import PullToRefresh from 'pulltorefreshjs';
import * as _ from 'lodash';

declare var $: any;
declare var moment: any;

import {NgbModal, NgbTooltipConfig} from "@ng-bootstrap/ng-bootstrap";
import {EditGoalDialogComponent} from "../../core/components/edit-goal-dialog/edit-goal-dialog.component";
import { HybridToolsService } from '../../core/services/hybrid-tools.service';
import {UiStateService} from "../../core/services/ui-state.service";
import {DatagridComponent} from "../../ui/datagrid/datagrid.component";
import {DonationService} from '../../core/services/donation.service';
import {UtilsService} from '../../core/services/utils.service';
import {HttpClient} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import {TotalRaisedDialogComponent} from "../../core/components/dialogs/total-raised-dialog/total-raised-dialog.component";

@Component({
    selector: 'page-donations',
    templateUrl: './donations.html',
    styleUrls: ['./donations.page.scss']
})

export class DonationsPage implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('donationsTable')
    donationsTableInstance: DatagridComponent;
    @ViewChild('promisesTable')
    promisesTableInstance: DatagridComponent;

    donations:any;

    promisesData: any;
    donationData: any;

    promiseGridOptions: any;
    donationGridOptions: any;
    currentModal: any;
    activeTab: string;
    facebookFundraiserUrl: string;
    isDonationPage: boolean;

    private eventSubscription;

    constructor(
        public eventService: EventService,
        private modalService: NgbModal,
        public uiStateService: UiStateService,
        private utilsService: UtilsService,
        private http: HttpClient,
        private ToastrService: ToastrService,
        private activatedRoute: ActivatedRoute,
        private donationService: DonationService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private app: ApplicationRef,
        private injector: Injector,
        private renderer: Renderer2,
        private angulartics2: Angulartics2,
        private location: Location,
        config: NgbTooltipConfig,
        public hybridToolsService: HybridToolsService
    ) {
        this.eventSubscription = this.eventService.onEventChange.subscribe(event => {
            this.updateTable();
            this.initFacebookFundraiserUrl();
        });
        config.placement = 'bottom';
    }

    ngOnInit() {
        this.isDonationPage = this.activatedRoute.snapshot.data.isDonationPage;
        this.setupTable();
        // Re-calculate responsive datatables when tab is switched.
        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            $( $.fn.dataTable.tables(true) ).DataTable().responsive.recalc();
        });

        this.activatedRoute.queryParams.subscribe((params: Params) => {
            this.activeTab = params['activeTab'];
        });

        this.initFacebookFundraiserUrl();
    }

    ngAfterViewInit() {
        if (PullToRefresh) {
            PullToRefresh.init({
                mainElement: '#donation-tables', // above which element?
                onRefresh: (done) => {
                    this.eventService.getDonationsTable(true).subscribe((response: any) => {
                        this.eventService.updateFunds(response);
                        this.updateTable();
                        done();
                    });
                }
            });
        }

        if (this.donationsTableInstance) {
            this.donationsTableInstance.bindClick('.hide-donation-amount', (event) => {
                var val = $("input[name='hideDonationAmount']:checked").val(),
                    fundID = $("input[name='hideDonationAmount']:checked").data('id')

                this.http.post('/api/v1/funds/' + fundID + '/options', {
                    donationAmountHidden: (val === 'yes')
                }).subscribe(() => {
                    this.ToastrService.success("Setting changed successfully.");
                }, err => {
                    this.ToastrService.error("There was problem saving the setting.");
                });
            });
            this.donationsTableInstance.bindClick('.hide-message', (event) => {
                var val = $("input[name='hideMessage']:checked").val(),
                    commentID = $("input[name='hideMessage']:checked").data('id')

                this.http.post('/api/v1/comments/' + commentID, {
                    isVisible: (val === 'no')
                }).subscribe(() => {
                    this.ToastrService.success("Setting changed successfully.");
                }, err => {
                    this.ToastrService.error("There was problem saving the setting.");
                });
            });
        }

        // This controls the display of the the associated donations
        if (this.promisesTableInstance) {
            this.promisesTableInstance.bindClick('> tbody > tr > td.control', (event) => {
                var tr = $(event.target).parents('tr');
                var row = this.promisesTableInstance.dtInstance.row(tr);
                var identifier = row.data().promiseId.replace(/ /g,'');
                $('tr.promise-children-' + identifier).remove();
                if (tr.next().hasClass('child')) {
                    this.showPromiseChildren(event.target, row.data(), identifier);
                }
            });
        }
    }

    ngOnDestroy() {
        this.eventSubscription.unsubscribe();
        if (PullToRefresh) {
            PullToRefresh.destroyAll();
        }
    }

    initFacebookFundraiserUrl() {
        var participant = this.eventService.selectedEvent.gql.Participant[0];
        if(participant && participant.fundraiser.activeFacebookFundraiserProfiles.length > 0) {
            this.facebookFundraiserUrl = 'https://www.facebook.com/donate/' + participant.fundraiser.activeFacebookFundraiserProfiles[0].facebookFundraiserId + '/';
        }
    }

    showTablePaginator(data) {
        if (data.length < 10) {
            $('.dataTables_paginate ').hide();
        } else {
            $('.dataTables_paginate ').show();
        }
    }

    onTabChange(event) {
        this.location.go('/donations', 'activeTab=' + event.nextId);
    }

    updateTable() {
        this.setupTable();
        if (this.donationsTableInstance) {
            this.donationsTableInstance.replaceData(this.donationData.donationList);
            this.showTablePaginator(this.donationData.donationList);
        }
        if (this.promisesTableInstance) {
            this.promisesTableInstance.replaceData(this.promisesData);
            this.showTablePaginator(this.promisesData);
        }
    }

    setupTable() {

        if (this.promisesTableInstance) {
            this.promisesTableInstance.dtInstance.search('');
        }
        if (this.donationsTableInstance) {
            this.donationsTableInstance.dtInstance.search('');
        }

        this.donationData = this.eventService.selectedEvent.donations;
        this.promisesData = this.eventService.selectedEvent.promises;

        this.promiseGridOptions = {
            // ajax: 'data/data.json',
            data: this.promisesData,
            columns: [
                {
                    title: 'Date',
                    data: 'donationDate',
                    class: 'date-col',
                    width: 125,
                    type: 'date',
                    responsivePriority: 1,
                    render: (x) => {
						//display as local time rather than UTC
                        return moment(x).format('MM/DD/YYYY h:mm a');
                    }
                },
                {title: 'Type', data: 'fundType'},
                {title: 'Donor', data: 'donorName', responsivePriority: 2},
                {title: 'Promised', data: 'promised', type: 'currency', responsivePriority: 1},
                {title: 'Matching Gift Included in Total', data: 'included', class: 'text-center'},
                {
					title: '',
					data: 'distributors',
					className: 'none',
                    render: ( data, type, row ) => {
						return '<div class="' + row.promiseId.replace(/ /g,'') + '"></div>';
                    }
				}
            ],
			initComplete: function() {
				this.on('responsive-display.dt', function (e, datatable, row, showHide, update) {

					var columns = 0;

					datatable.columns().every(function () {
						if ($(this.header()).is(":visible")) {
							columns++;
						}
					});

					$.each($('tr.promise-children > td.child'), function(index, value) {
						var td = $(value);
						td.attr('colspan', columns);
					});
				});
			}
        };

        this.donationGridOptions = {
            // ajax: 'data/data.json',
            data: this.donationData.donationList,
            responsive: {
                details: {
                    type: 'column',
                    target: -1
                }
            },
            // rowExpand: {
            //    columnName: 'Donor Info',
            //    buttonName: 'More info',
            //    responsivePriority: 1,
            //    render: () => {
            //        return '<a href class="expand-row">' + 'More info' + '</a>';
            //    }
            // },
            columns: [
                {
                    title: 'Date',
                    data: 'donationDate',
                    class: 'date-col',
                    width: 125,
                    type: 'date',
                    responsivePriority: 1,
                    render: (x) => {
                        //display as local time rather than UTC
                        return moment(x).format('MM/DD/YYYY h:mm a');
                    }
                },
                {title: 'Contributor', data: 'fullName', responsivePriority: 1},
                {title: 'Amount', data: 'amount', type: 'currency', responsivePriority: 2},
                {title: 'Method', data: 'paymentMethod'},
                {title: 'Type', data: 'donationType'},
                {title: 'Source', data: 'source'},
                {title: 'Status', data: 'status', class: 'text-right'},
                {title: 'Fund Type', data: 'fundType'},
                {
                    title: 'Address',
                    data: 'raw',
                    className: 'none',
                    render: (x) => {
                        return this.utilsService.formatAddress(x);
                    }
                },
                {title: 'Email', data: 'donorEmail', className: 'none'},
                {
                    title: 'Phone',
                    data: 'raw',
                    className: 'none',
                    render: (x) => {
                        return this.utilsService.formatPhone(x);
                    }
                },
                {title: 'Display name', data: 'donorDisplayName', className: 'none'},
                {
                    title: 'Hide Donation Amount?',
                    data: 'raw',
                    className: 'none',
                    render: (x) => {
                        return '<label class="form-check-label custom-control custom-radio mb-0">' +
                                    '<input data-id="' + x.participantFundsId + '"' +
                                    ' class="form-check-input custom-control-input hide-donation-amount"' +
                                    ' type="radio"' +
                                    ' name="hideDonationAmount"' +
                                    ' value="no"' + (x.fundraiserPageDisplayAmountType.name === 'SHOW_AMOUNT' ? 'checked' : '') + '/>' +
                                    '<span class="custom-control-label"></span>' +
                                    '<span class="custom-control-description">No</span>' +
                                '</label>' +
                                '<label class="form-check-label custom-control custom-radio mb-0">' +
                                    '<input data-id="' + x.participantFundsId + '"' +
                                    ' class="form-check-input custom-control-input hide-donation-amount"' +
                                    ' type="radio"' +
                                    ' name="hideDonationAmount"' +
                                    ' value="yes"' + (x.fundraiserPageDisplayAmountType.name === 'SHOW_AMOUNT' ? '' : 'checked') + '/>' +
                                    '<span class="custom-control-label"></span>' +
                                    '<span class="custom-control-description">Yes</span>' +
                                '</label>';
                    }
                },
                {
				    title: 'Donor Message',
                    data: 'donorMessage',
                    className: 'none',
                    render: (x) => {
                        return x ? $('<div>').text(x).html() : 'N/A';
                    }
                },
                {
                    title: 'Hide message?',
                    data: 'raw',
                    className: 'none',
                    render: (x) => {
                        return '<label class="form-check-label custom-control custom-radio mb-0">' +
                                    '<input data-id="' + x.donorMessageId + '"' +
                                    ' class="form-check-input custom-control-input hide-message"' +
                                    ' type="radio"' +
                                    ' name="hideMessage"' +
                                    ' value="no"' + (x.showComments === true ? 'checked' : '') + ' ' + (x.donorMessageId ? '' : 'disabled') + '/>' +
                                    '<span class="custom-control-label"></span>' +
                                    '<span class="custom-control-description">No</span>' +
                                '</label>' +
                                '<label class="form-check-label custom-control custom-radio mb-0">' +
                                    '<input data-id="' + x.donorMessageId + '"' +
                                    ' class="form-check-input custom-control-input hide-message"' +
                                    ' type="radio"' +
                                    ' name="hideMessage"' +
                                    ' value="yes"' + (x.showComments === true ? '' : 'checked') + ' ' + (x.donorMessageId ? '' : 'disabled') + '/>' +
                                    '<span class="custom-control-label"></span>' +
                                    '<span class="custom-control-description">Yes</span>' +
                                '</label>';
                    }
				},
				{
					title: 'Is Monthly Recurring',
					data: 'recurringFlag',
					className: 'none',
					render: (x) => {
                        return x ? 'Yes' : 'No';
                    }
				},
				{
					title: 'Donor Covered Fee',
					data: 'hasDcf',
					className: 'none',
					render: (x) => {
                        return x ? 'Yes' : 'No';
                    }
				},
				{
					title: 'Company Matching',
					data: 'companyMatching',
					className: 'none',
					render: (x) => {
                        return x ? 'Yes' : 'No';
                    }
				},
				{
					title: 'Company Name',
					data: 'donorMatchingCompanyName',
					className: 'none',
					render: (x) => {
                        return x ? $('<div>').text(x).html() : 'N/A';
                    }
				},
				{
					title: 'In Honor Of',
					data: 'honoree',
					className: 'none',
					render: (x) => {
                        return x ? $('<div>').text(x).html() : 'N/A';
                    }
				},
				{
					title: 'Donation Description',
					data: 'donationDescription',
					className: 'none',
					render: (x) => {
                        return x ? $('<div>').text(x).html() : 'N/A';
                    }
				},
                {
                    className: 'control',
                    sortable: false,
                    render: (x) => {
                        return '';
                    },
                    responsivePriority: 3
                },
            ]
        };
    }

    openModal(content) {
        this.currentModal = this.modalService.open(content);
    }

    openChangeGoalModal() {
        const editGoalModal = this.modalService.open(EditGoalDialogComponent);
        editGoalModal.componentInstance.totalRaised = this.eventService.getIndividualTotalRaised();
    }

    openTotalRaisedModal() {
        const totalRaisedModal = this.modalService.open(TotalRaisedDialogComponent);
        totalRaisedModal.componentInstance.totalRaised = this.eventService.selectedEvent.donations.individual.totalRaised;
        totalRaisedModal.componentInstance.donationsReceived = this.eventService.selectedEvent.gql.Participant[0].fundraiser.donationsReceived;
        totalRaisedModal.componentInstance.facebookDonationsAmount = this.eventService.selectedEvent.gql.Participant[0].fundraiser.facebookDonationsAmount;
        totalRaisedModal.componentInstance.promises = this.eventService.selectedEvent.donations.individual.outstandingPromises;
        totalRaisedModal.componentInstance.isNationalTeam = false;
    }

    private showPromiseChildren(target, promise, parent) {
        var options = _.cloneDeep(this.donationGridOptions);
        options.data = promise.distributors;
        options.dom = 't';

        //https://medium.com/@tudorgergely/injecting-components-dynamically-in-angular-2-3d36594d49a0
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(DatagridComponent);
        const componentRef = componentFactory.create(this.injector);

        componentRef.instance.options = options;
        componentRef.changeDetectorRef.detectChanges();

        var columns = 0;

        this.promisesTableInstance.dtInstance.columns().every(function() {
            if ($(this.header()).is(":visible")) {
                columns++;
            }
        });

        let child = $('div.' + parent)
            .parents('tr.child')
            .after("<tr class='child promise-children promise-children-" + parent + "'>"
                + "<td class='child' colspan='" + columns + "'><ul class='dtr-details'><li><span class='dtr-title'>Funds Received</span><span class='dtr-data'></span></li></ul></td></tr>")
            .next().find('td.child span.dtr-data');

        this.renderer.appendChild(
            child[0],
            componentRef.location.nativeElement
        );
        this.app.attachView(componentRef.hostView);
    }
}

